import { useLayoutEffect, useState } from "react";

const MIN_LIST_HEIGHT = 240;

/**
 * Room left to a list down to the bottom of the visible wizard, so the list scrolls inside and
 * the page does not. What sits under the list (switch, pagination, paddings, the room kept for
 * the fixed action bar) is measured down to the bottom of the wizard body, which does not depend
 * on the list's own height. `measureKey` changes whenever the layout around the list may have
 * moved; a hidden list (inactive tab) is not measured.
 */
const useListFillHeight = (listRef, isActive, measureKey) => {
    const [listHeight, setListHeight] = useState(null);

    useLayoutEffect(() => {
        if (!isActive) return undefined;
        const measure = () => {
            const list = listRef.current;
            const body = list?.closest("[data-mission-wizard-body]");
            if (!list || !body || list.offsetParent === null) return;
            let scroller = body.parentElement;
            while (scroller && !/(auto|scroll)/.test(getComputedStyle(scroller).overflowY)) {
                scroller = scroller.parentElement;
            }
            if (!scroller) return;
            const listBox = list.getBoundingClientRect();
            const below = body.getBoundingClientRect().bottom - listBox.bottom;
            const visibleBottom = scroller.getBoundingClientRect().top + scroller.clientHeight;
            setListHeight(Math.max(MIN_LIST_HEIGHT, Math.floor(visibleBottom - listBox.top - below)));
        };
        measure();
        window.addEventListener("resize", measure);
        return () => window.removeEventListener("resize", measure);
    }, [listRef, isActive, measureKey]);

    return listHeight;
};

export default useListFillHeight;
